import React from "react";
import { Contact, Header, Hire } from "./Components";

const CareerEpisodeWriting = () => {
  return (
    <div className="servicesPages">
      <Header
        header="Three Career Episodes included in your CDR report for Engineers Australia"
        desc="To secure a positive outcome in the migration skills assessment, you must provide three distinct career episodes that showcase your skills, expertise, and various competencies through diverse projects."
      />
      <div className="body">
        <div>
          <div className="header">What is Career Episode Writing?</div>
          <div className="desc">
            A Career Episode is a vital part of the CDR report, designed to highlight your engineering skills, knowledge, capabilities, and professional experience. Engineers
            Australia assesses these career episodes to determine your eligibility for a skilled migration visa.
          </div>
          <div className="desc">
            Each CDR comprises three career episodes, with each episode focusing on a distinct project from your final year of engineering, an internship, or work-related tasks. At
            CDR Report Hub, we provide expert Career Episode Writing services, tailored to reflect your unique professional experiences, ensuring that all three episodes are
            crafted to stand out individually.
          </div>
          <div className="header">Why Are Career Episodes Important?</div>
          <div className="desc">
            Engineers without an Australian engineering degree must prove their competency to Engineers Australia (EA) to qualify for skilled migration. EA assesses your skills to
            ensure that you are equipped to work in the Australian job market and pose no risk to the economy. For this purpose, EA has developed the Competency Demonstration
            Report (CDR) as part of their skill assessment process for migrating engineers.
          </div>
          <div className="desc">
            A CDR includes three Career Episodes, which play a crucial role in demonstrating your engineering expertise and knowledge. These episodes focus on projects or tasks
            from your final year of engineering, internship, or relevant work experience. Through these Career Episodes, EA evaluates the depth of your engineering skills and
            competencies.
          </div>
          <div className="desc">
            A well-crafted Career Episode is essential for a successful assessment, ensuring that you meet EA’s standards and gain approval for migration to Australia.
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default CareerEpisodeWriting;
